import api from "../../components/commonComponents/axiosSetup"
import { BASE_URL } from "../../config";
import { accountName } from "../customerManagement/utility/authUtils";

const accName = accountName();
export const saveDataWhiteList= async(payload)=>{

    try {
        const response = await api.post("192.168.30.33/saveWhiteList", payload);
        return response.data
    } catch (error) {
        console.log(error)
    }
}
export const fetchDataWhiteList= async()=>{

    try {
        const response = await api.get(`${BASE_URL}api/airtel/data/whitelist/all`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const fetchBulkWhiteListData= async()=>{

    try {
        const response = await api.get(`${BASE_URL}bulk/all?whitelist=true&accountName=${accName}`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const fetchBulkTransactionData= async()=>{

    try {
        const response = await api.get(`${BASE_URL}bulk/all?accountName=${accName}`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const updateDataWhiteList= async(payload)=>{

    try {
        const response = await api.post("192.168.30.33/saveWhiteList", payload);
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export const getSMSWhitelist= async(
    pageNo = 0,
  pageSize = 10
)=>{

    try {
        const response = await api.get(`${BASE_URL}api/sms/whitelist/get?page=${pageNo}&size=${pageSize}`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}


export const generateWhiteListReport= async()=>{

    try {
        const response = await api.get(`${BASE_URL}api/airtel/data/whitelist/all`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}